<template>
    <div class="grid grid-cols-12 gap-4 md:gap-8">
        <div class="col-span-12 md:col-span-4 space-y-2">
            <div class="font-medium text-gray-700">
                <slot name="title" />
            </div>
            <div
                v-if="slots.subtitle"
                class="text-sm text-gray-600"
            >
                <slot name="subtitle" />
            </div>
        </div>
        <div class="col-span-12 md:col-span-8 space-y-4">
            <Card v-if="slots.content">
                <template #content>
                    <slot name="content" />
                </template>
            </Card>
            <slot
                v-else-if="slots.rawContent"
                name="rawContent"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'
    import Card from '@/Shared/Component/Card.vue'

    const slots: any = useSlots()
</script>
